module.exports = __webpack_public_path__ + "static/media/scalability.2d313641.png";